import { SupportConfigTemplateItem } from "./SupportConfigTemplate";

export const SupportConfigTemplateScreen = () => {
  return <SupportConfigTemplateItem />;
};
